import { render } from "./CommissionCard.vue?vue&type=template&id=58566f70&scoped=true"
import script from "./CommissionCard.vue?vue&type=script&lang=js"
export * from "./CommissionCard.vue?vue&type=script&lang=js"

import "./CommissionCard.vue?vue&type=style&index=0&id=58566f70&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58566f70"]])

export default __exports__